import { useState, useEffect, useRef } from "react";
import backgroundimg from "../Images/banner-bg.jpg";
import emailjs from "emailjs-com";
import { countriesList } from "../utility/constants";
import { useMediaQuery } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { medicals } from "./config";
import NukaCarousel from "../tools/NukaCarousel";
import { faqs } from "./config";
import { medi } from "./config";
import { faqsss } from "./config";
import docgirl from "../Images/home/medical-loan-clipart.png";
import CenteredAlert from "./CenteredAlert";
import HospitalTreatmentsShowcase from "./HospitalTreatmentsShowcase";
import { ArrowRight, CheckCircle, Phone, Mail, Clock , MapPin, User, Send, FileText, Heart , MessageSquare, Users, DollarSign, Headphones , Plus, Minus , Truck , Shield , Smartphone, FileCheck , HeartHandshake ,CreditCard } from 'lucide-react';
import {
  TextField,
  Button,
  Container,
  makeStyles,
  FormControl,
  InputLabel,
  InputAdornment,
  Input,
  MenuItem,
  FormHelperText,
  Select,
  Grid,
} from "@material-ui/core";
import ServiceCall from "../ServiceCall";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(4),
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(2, 0),
    backgroundColor: "#199a8e",
    "&:hover": {
      // Remove hover effect
      backgroundColor: "#199a8e",
    },
  },
  salutationFormControl: {
    width: "27%", // Adjust the width of the salutation select
  },
  gender: {
    width: "30%",
  },
  nameContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  nameField: {
    background: "white",
  },
  select: {
    border: "none", // Remove border
    width: "50px", // Adjust the width as needed
  },
}));

const Medicalloan = () => {
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [phoneCode, setPhoneCode] = useState("+91");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [pin, setPin] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const isMobile = useMediaQuery("(max-width:710px)");
  const isValidPhoneNumber = (phoneNumber) => {
    const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
    return numericPhoneNumber.length === 10 && /^\d+$/.test(numericPhoneNumber);
  };
  const [expandedQuestions, setExpandedQuestions] = useState([]);
const [loading, setLoading] = useState(false);
const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
   const [submitted, setSubmitted] = useState(false);
   const handleContactNowClick = () => {
  const section = document.getElementById("consultation");
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
  const [showAlert, setShowAlert] = useState(false);
   const formRef = useRef(null);
   const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const mode = process.env.REACT_APP_MODE; // e.g., 'dev', 'prod'

  const payload = {
    email: formData.email,
    country_code: '+91', // 🔧 Replace with dynamic code if available
    phone: formData.phone,
    name: formData.name,
    address: formData.address,
    source_url: 'https://rxone.app/medical-finance-loan-india',
    request_type: 'medical-finance-loan-india',
    coupon_code: '' // 🔧 Optional: add value if needed
  };

  try {
    await ServiceCall.post(`/rxopd/rxone/patient/treatment/advice/contactus/form/${mode}`, payload);

    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', address: '' });
      setSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error('API submission error:', error);
    alert('Failed to submit the form. Please try again.');
  } finally {
    setLoading(false);
  }
};
  const [expandedId, setExpandedId] = useState(null);
  const toggle = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };
  const toggleQuestion = (id) => {
    if (expandedQuestions.includes(id)) {
      setExpandedQuestions(expandedQuestions.filter((qid) => qid !== id));
    } else {
      setExpandedQuestions([...expandedQuestions, id]);
    }
  };
const coverage = [
  {
    icon: <HeartHandshake className="w-8 h-8 text-teal-600" />,
    title: "Medical Emergencies",
    description: "Immediate financial support for urgent medical treatments and hospital expenses",
  },
  {
    icon: <FileCheck className="w-8 h-8 text-teal-600" />,
    title: "Infertility Treatment",
    description: "Complete cycle financing for infertility treatments and related medical procedures",
  },
  {
    icon: <CreditCard className="w-8 h-8 text-teal-600" />,
    title: "Cosmetic Surgeries",
    description: "Flexible financing options for cosmetic and elective surgical procedures",
  },
];
  const titlle =
    "FREE Treatment Advice - Consult for Medicalloan Treatment Advice - Allopathy, Homeopathy, Ayurveda, Unani, Sowa-Rigpa, Siddha, Yoga, Reki, Naturopathy, Meditation, Physiotherapy, Mental Health | RxOne";
  const desc =
    "Get free treatment advice and consult for medical treatments including Allopathy, Homeopathy, Ayurveda, Unani, Sowa-Rigpa, Siddha, Yoga, Reki, Naturopathy, Meditation, Physiotherapy, and Mental Health at RxOne.";
    
  return (
    <>
      <Helmet>{<title>{titlle}</title>}</Helmet>
      <Helmet>{<meta name="description" content={desc} />}</Helmet>

       <div className="bg-gradient-to-br from-teal-100 via-white to-blue-50 min-h-screen">
    <section id="consultation" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 mt-20 ">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Finance your <span className="text-teal-600">Medical Emergencies </span> Get Instant loans up to<span className="text-teal-600"> ₹5,00,000</span>
              </h1>
              <p className="mt-6 text-xl text-gray-600 leading-relaxed">
               Don't let financial constraints delay your medical treatment. Get instant approval for medical loans with minimal documentation and quick disbursal.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-4">
              <a href="#services" className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg shadow-md hover:bg-teal-700 transition-colors">
                Contact Us
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
       {/* <a
  href="#contact"
  className="inline-flex items-center px-6 py-3 bg-white text-teal-600 border border-teal-600 font-medium rounded-lg transition-colors hover:bg-teal-50 hover:text-teal-700 hover:border-teal-700"
>
  Contact Us
</a> */}

            </div>
            
            <div className="space-y-4 pt-2">
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <CheckCircle className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Instant Approval</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <Shield className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">100% Secure</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                  <CheckCircle className="h-6 w-6" />
                </div>
                <span className="text-gray-700 font-medium">Quick Disbursal</span>
              </div>
            </div>
          </div>
          
          <div>
         
 

   <div className="lg:pl-12" ref={formRef}>
  <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
    {/* Decorative Elements */}
    <div className="absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>
    <div className="absolute bottom-0 left-0 w-24 h-24 opacity-5 transform -rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>

    {submitted ? (
      <div className="text-center py-4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(1, 154, 158, 0.1)' }}>
          <CheckCircle className="w-8 h-8" style={{ color: 'rgb(1, 154, 158)' }} />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-1">Thank You!</h3>
        <p className="text-sm text-gray-600">Your message has been sent successfully. We'll get back to you soon.</p>
      </div>
    ) : (
      <>
       <div className="text-center mb-4">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-3 flex items-center justify-center gap-3">
  <span
    style={{
      letterSpacing: "1px",
      // textTransform: "uppercase",
      background: "linear-gradient(90deg, #019a9e 0%, #00c6b7 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      display: "inline-block"
    }}
  >
    Contact Now 
  </span>
  {/* <img
    src={phantompic}
    alt="PanTum Logo"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      height: "30px",
      marginBottom: "2px"
    }}
  /> */}
</h2>
  <p className="text-sm text-gray-600">
    Fill out the form and we'll contact you within 24 hours
  </p>
</div>

        <div className="space-y-4">
          {/* Name Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <User className="w-4 h-4 mr-2 text-gray-500" />
              Full Name *
            </label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Email Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Mail className="w-4 h-4 mr-2 text-gray-500" />
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Phone Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Phone className="w-4 h-4 mr-2 text-gray-500" />
              Phone Number *
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Address Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <MapPin className="w-4 h-4 mr-2 text-gray-500" />
              Address *
            </label>
            <textarea
              name="address"
              placeholder="Enter your complete address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white resize-none"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Submit Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className={`w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-xl'
            }`}
            style={{
              backgroundColor: loading ? '#gray' : 'rgb(1, 154, 158)',
              boxShadow: loading ? 'none' : '0 4px 15px rgba(1, 154, 158, 0.3)',
            }}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Submitting...
              </>
            ) : (
              <>
                <Send className="w-5 h-5 mr-2" />
                Submit
              </>
            )}
          </button>

          {/* Trust Indicators */}
          {/* <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
              <div className="flex items-center">
                <Shield className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                SSL Secured
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                No Spam
              </div>
              <div className="flex items-center">
                <Star className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                Trusted
              </div>
            </div>
          </div> */}
        </div>
      </>
    )}
  </div>
</div>


          </div>
        </div>
      </section>

      </div>
      {showAlert && (
        <CenteredAlert
          message="We have received your request, please allow us up-to 24 Hrs. to come back to you."
          onClose={() => setShowAlert(false)}
        />
      )}
      {/* <section
        style={{
          background: "linear-gradient(120deg, rgb(237, 233, 233), #edf2f7)",
        }}
        className="ms-apart-section"
      >
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-12 text-center">
              <h2 className="ms-font-weight-600 ms-primary-color">
                How it works?
              </h2>
            </div>
          </div>
          <div className="row g-9 justify-content-center">
            {medicals?.length > 0 ? (
              medicals.map((item, index) => (
                <div className="col-md-4 col-sm-6 mb-4" key={index}>
                  <div className="provider__revolutionize__item h-100">
                    <div className="provider__revolutionize__icon text-center">
                      <img src={item?.icon} alt={item?.alt} />
                    </div>
                    <h4 className="provider__revolutionize__title text-center ms-font-weight-600 mt-3 mb-4 ms-primary-color">
                      {item?.title}
                    </h4>
                    <h6 className="provider__revolutionize__text ms-2 mb-0 fw-normal text-center">
                      {item?.text}
                    </h6>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">No items to display</div>
            )}
          </div>
        </div>
      </section> */}
 <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Get your medical loan approved in just 3 simple steps
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {/* Step 1 */}
          <div className="text-center relative">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
              <FileText className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">1</span>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Fill the form and submit your application
            </h3>
            <p className="text-gray-600 leading-relaxed">
             Complete our simple online application form with your basic details, loan amount required, and purpose. Upload necessary documents for quick verification.
            </p>
            <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0">
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-teal-600 rounded-full"></div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="text-center relative">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
              <Phone className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">2</span>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Our expert will call you to confirm details
            </h3>
            <p className="text-gray-600 leading-relaxed">
            Our loan specialist will contact you within 30 minutes to verify your details, explain loan terms, and guide you through the approval process.
            </p>
            <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0">
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-teal-600 rounded-full"></div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
              <Smartphone className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">3</span>
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
             Get instant approval and fund transfer
            </h3>
            <p className="text-gray-600 leading-relaxed">
             Once approved, the loan amount will be transferred directly to your bank account within 24 hours. Track your application status on mobile.
            </p>
          </div>
        </div>

        {/* Custom CTA Button */}
        <div className="text-center mt-12">
        <button
  className="px-6 py-3 text-lg font-semibold text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition duration-300"
  onClick={handleContactNowClick}
>
  Contact Now
</button>
        </div>
      </div>
    </section>
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            What We Cover
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive medical financing for all your healthcare needs
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {coverage.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm p-6 text-center hover:shadow-lg transition-shadow"
            >
              <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-4">
                {item.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="py-16 bg-white">
          <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                 Medical Loans in India
              </h2>
              <p className="text-xl text-gray-600">
                Important information about our medical loan services
              </p>
            </div>
    
            <div className="bg-gray-50 rounded-lg p-8 space-y-6">
              <div className="text-gray-700 text-base leading-relaxed space-y-4">
                <p>
                    With the Increasing uncertainties in life and the spread of
            coronavirus, covering our medical costs is of utmost importance. Not
            everyone in India can afford to have a good premium insurance plan
            to cover treatment costs at a big hospital. It is at times like
            these, RxOne comes to your rescue by helping you get easy and
            hassle-free medical emergency loans.
                </p>
    
                <p>
                  When a medical emergency arrives, worrying about funds should be the
            last thing on your mind so fill your medical loan application form
            now and finance your medical expenses, the cycle of infertility
            treatment, or even cosmetic surgeries
                </p>
               <p>
      <strong>RxOne helps you to get easy access to an unsecured personal loan
            for medical treatment for a tenure of 6 months to 36 months starting
            from 20,000 up to 5,00,000 So, check your eligibility. compare
            interest rates, and apply for a medical loan in India to all banks
            and NBFC's using RxOne.</strong>
    </p>
              </div>
    
              <div className="border-t border-gray-200 pt-6">
                <div className="flex items-center space-x-3">
                  <Shield className="w-6 h-6 text-teal-600" />
                  <span className="text-sm text-gray-600 font-medium">
                    By placing an order, you agree to these terms and conditions
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <HospitalTreatmentsShowcase/>
      <section className="py-16 bg-teal-600">
          <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
               Don't Let Financial Constraints Delay Your Treatment
            </h2>
            <p className="text-xl text-white/90 mb-8">
             Get instant medical loans up to ₹5,00,000 with minimal documentation. Apply now and get approval within 30 minutes.
            </p>
            <button className="px-6 py-3 bg-white text-teal-600 text-lg font-semibold rounded-lg hover:bg-gray-100 transition duration-300" onClick={handleContactNowClick} >
               Apply for Medical Loan Now
            </button>
          </div>
        </section>
          
    
            <section className="py-20 bg-gray-50">
          <div className="w-full px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-10 text-center">
                Frequently Asked Questions
              </h2>
          
              <div className="space-y-5">
               {medi.map((faq) => (
                  <div
                    key={faq.id}
                    className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-300"
                  >
                    <button
                      onClick={() => toggle(faq.id)}
                      className="flex justify-between items-center w-full px-4 py-4 text-left text-gray-800 font-medium hover:bg-gray-100 focus:outline-none"
                    >
                      <span className="text-sm sm:text-base">{faq.question}</span>
                      <span className="ml-4 text-teal-600">
                        {expandedId === faq.id ? <Minus size={18} /> : <Plus size={18} />}
                      </span>
                    </button>
          
                    <div
                      className={`px-4 pt-0 pb-4 text-gray-600 text-sm transition-all duration-300 ${
                        expandedId === faq.id ? 'block' : 'hidden'
                      }`}
                    >
                      {faq.answer}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
     
    
    </>
  );
};
export default Medicalloan;
